import React from 'react'

export default () => {
  return (
    <div className="row">
      <div className="col-md-12 text-center">
        <small style={{ fontSize: '15px' }}>
          &copy; 2018 all rights reserved. flyroraima.com
        </small>
      </div>
    </div>
  )
}
